import Vue from 'vue'
import decodePolyline from 'decode-google-map-polyline'
import GeoJSON from 'geojson'

const MOVERICK_PLANNER_LOCALSTORAGE = 'moverick-planner-options'
const VALID_TRANSIT = ['BUS', 'INTERCITY_BUS', 'TROLLEYBUS', 'COMMUTER_TRAIN', 'FUNICULAR',
  'HEAVY_RAIL', 'HIGH_SPEED_TRAIN', 'METRO_RAIL', 'MONORAIL', 'RAIL', 'SUBWAY', 'TRAM']

/**
 * FUNCIONES AUXILIARES DE PREPARACIÓN DE FECHAS, TEXTOS, ETC
 * */

// Convertir duración al formato esperado por Google
function convertDurationToJSON(durationInSeconds) {
  // Convertimos los segundos a minutos y horas
  const minutes = Math.floor(durationInSeconds / 60)
  const hours = Math.floor(minutes / 60)

  // Creamos el objeto JSON
  const json = {
    text: '',
    value: durationInSeconds
  }

  // Construimos el texto en base a los minutos y horas
  if (hours > 0) {
    json.text += hours + (hours === 1 ? ' hora' : ' horas')
    if (minutes % 60 > 0) {
      json.text += ' y '
    }
  }
  if (minutes % 60 > 0) {
    json.text += (minutes % 60) + (minutes % 60 === 1 ? ' minuto' : ' minutos')
  }

  return json
}

// Convertir tiempo en milisegundos a formato JSON de Google
function convertToTimeJSON(timeInMiliSeconds, agencyTimeZoneOffset) {
  const options = JSON.parse(localStorage.getItem(MOVERICK_PLANNER_LOCALSTORAGE))
  const timeZone = options.administrativeAreaTimeZone

  // Se comenta esta funcionalidad que sirve para ajustar la hora a la zona horaria del usuario
  // con la que se ha realizado la búsqueda de rutas.
  // En nuestro caso, no es necesario ya que ese procesado se realiza en OTP y
  // en nuestra aplicación por lo que es redundante
  // timeInMiliSeconds += agencyTimeZoneOffset

  const lang = 'es'

  const month = new Date(timeInMiliSeconds).toLocaleDateString(lang,
    {timeZone, month: 'short'})
  const day = new Date(timeInMiliSeconds).toLocaleDateString(lang, {
    timeZone,
    day: '2-digit'
  })
  const hour = new Date(timeInMiliSeconds).toLocaleTimeString(
    navigator.language, {
      timeZone,
      hour: '2-digit',
      minute: '2-digit'
    }
  )

  const json = {
    text: `${day} ${month[0].toUpperCase()}${month.substring(1)} ${hour}`,
    time_zone: timeZone,
    value: timeInMiliSeconds
  }

  return json
}

// Convertir distancia en metros al formato JSON de Google
function convertDistanceToJSON(distanceInMeters) {
  const distanceInKilometers = distanceInMeters / 1000
  const roundedDistanceInKilometers = Math.round(distanceInKilometers * 10) / 10

  // Formateamos la distancia en formato '0,2 km'
  const formattedDistance = `${roundedDistanceInKilometers.toString().replace('.', ',')} km`

  // Creamos el objeto JSON con el texto calculado
  const json = {
    text: formattedDistance,
    value: distanceInMeters
  }

  return json
}

// Función auxiliar para preparar geometría de polilínea a GeoJSON
function composeGeometryFromLegs(legs) {
  const pointsArray = []

  // Recorremos cada leg y agregamos sus puntos al array de puntos
  legs.forEach(leg => {
    const legPoints = decodePolyline(leg.legGeometry.points)
    pointsArray.push(...legPoints)
  })

  return pointsArray
}

function getIdFromToBicycleRent ( leg ) {
    if( leg.rentedBike ) {
      return { to: leg.to.bikeShareId, from: leg.from.bikeShareId }
    }
}

// Convierte los tipos de viaje devueltos por OTP al formato Google
function convertToGoogleTravelMode(otpTravelMode) {
  switch (otpTravelMode) {
    case 'CAR':
      return 'DRIVING'
    case 'WALK':
      return 'WALKING'
    case 'BIKE':
      return 'BICYCLING'
    case 'BUS':
    case 'INTERCITY_BUS':
    case 'TROLLEYBUS':
    case 'COMMUTER_TRAIN':
    case 'FUNICULAR':
    case 'HEAVY_RAIL':
    case 'HIGH_SPEED_TRAIN':
    case 'METRO_RAIL':
    case 'MONORAIL':
    case 'RAIL':
    case 'SUBWAY':
    case 'TRAM':
      return 'TRANSIT'
    default:
      // Si el tipo no coincide con ninguno conocido,
      // devolvemos null o el valor original según convenga.
      // Puedes personalizar esto según tus necesidades.
      return null
  }
}

function formatTime(date) {
  let hours = date.getHours()
  let minutes = date.getMinutes()
  const amOrPm = hours >= 12 ? 'pm' : 'am'

  // Convertir a formato AM/PM
  hours = hours % 12 || 12

  // Agregar ceros a la izquierda si es necesario
  hours = hours.toString().padStart(2, '0')
  minutes = minutes.toString().padStart(2, '0')

  return `${hours}:${minutes}${amOrPm}`
}

function formatDate(date) {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()

  return `${month}-${day}-${year}`
}

// Función que obtiene la información para Line del formato Google
// a partir de OTP, que muestra esa información directamente en leg
function mapLine(leg) {
  const lineData = {
    color: `#${leg.routeColor}`,
    name: leg.routeLongName,
    short_name: leg.routeShortName,
    text_color: `#${leg.routeTextColor}`,
    url: leg.agencyUrl,
    icon: null //Sin uso
  }

  if (leg.agencyName !== undefined) {
    const agency = {
      name: leg.agencyName,
      phone: 'agency.phone', // Opcional
      url: leg.agencyUrl
    }

    lineData.agencies = []
    lineData.agencies.push(agency)
  }

  const vehicleData = {
    name: leg.routeShortName,
    type: leg.mode,
    // Información de vehículo sin uso por el momento
    icon: 'vehicle.icon',
    local_icon: 'vehicle.local_icon'
  }

  lineData.vehicle = vehicleData

  return lineData
}

/* FUNCIÓN QUE ESTIMARÍA EL COSTE, SIN USO POR EL MOMENTO

function mapFare(fareData) {
  return {
    currency: fareData.currency,
    value: fareData.value,
    text: fareData.text
  }
}
*/

// Función para mapear el tránsito desde la información de agencia de OTP
// a un step individual al estilo Google
function mapTransit(leg) {
  const transitData = {
    arrival_stop: {
      location: {
        lat: leg.to.lat,
        lng: leg.to.lng
      },
      name: leg.to.name
    },
    arrival_time: convertToTimeJSON(leg.to.arrival, leg.agencyTimeZoneOffset),
    departure_stop: {
      location: {
        lat: leg.from.lat,
        lng: leg.from.lng
      },
      name: leg.from.name
    },
    departure_time: convertToTimeJSON(leg.from.departure, leg.agencyTimeZoneOffset),
    headsign: leg.headsign,
    headway: leg.headway ? leg.headway : null,
    num_stops: leg.intermediateStops.length,
    trip_short_name: leg.routeShortName,
    steps_directions : leg.intermediateStops
  }

  if (leg.transitLeg !== undefined) {
    transitData.line = mapLine(leg)
  }

  return transitData
}

// Función para mapear los steps (de Google) a partir de los legs (de OTP). Step Google = Legs OTP
function mapLegSteps(legs) {
  return _.map(legs, leg => {
    const points = decodePolyline(leg.legGeometry.points)
    const stepData = {
      distance: convertDistanceToJSON(leg.distance),
      duration: convertDurationToJSON(leg.duration),
      end_point: points[points.length - 1],
      polyline: points,
      start_point: points[0],
      travel_mode: convertToGoogleTravelMode(leg.mode),
      mode:leg.mode,
      rentedBike:leg.rentedBike,
      steps_directions:leg.steps,
      style: {},
      agencyId : leg.agencyId ? leg.agencyId : '',
      info_id_rent_bicicle_stops: getIdFromToBicycleRent(leg)
    }

    const polylineData = stepData.polyline.map(item => ([item.lng, item.lat]))

    if (polylineData.length === 0) {
      stepData.polyline = undefined
    }
    const dataPoints = {
      polyline: polylineData
    }
    const geojson = GeoJSON.parse(dataPoints, {LineString: 'polyline'})
    stepData.polyline = geojson

    if (VALID_TRANSIT.includes(leg.mode)) {
      stepData.transit = mapTransit(leg)
    }

    return stepData
  })
}

// Función para procesar una ruta individual y convertirla al formato Google Directions API
function mapRoute(itinerary) {
  const pointsArray = composeGeometryFromLegs(itinerary.legs)

  // Recogemos las opciones al pulsar el botón buscar ruta, almacenadas
  // en el storage local
  const options = JSON.parse(localStorage.getItem(MOVERICK_PLANNER_LOCALSTORAGE))
  const agencyTimeZoneOffset = itinerary.legs.length > 0 && itinerary.legs[0].agencyTimeZoneOffset ?
    itinerary.legs[0].agencyTimeZoneOffset : 0

  const legUniqueData = {
    arrival_time: convertToTimeJSON(itinerary.endTime, agencyTimeZoneOffset),
    departure_time: convertToTimeJSON(itinerary.startTime, agencyTimeZoneOffset),
    distance: itinerary.distance !== undefined ? convertDistanceToJSON(itinerary.distance) : null, // Verificación de `undefined`
    duration: convertDurationToJSON(itinerary.duration),
    end_address: options.destination,
    start_address: options.origin,
    steps: mapLegSteps(itinerary.legs),
    stops: [],
    start_address_text: options.originDirection,
    end_address_text: options.destinationDirection,
  }

  const routeData = {
    copyrights: 'OpenTripPlanner',
    polyline: pointsArray,
    warnings: null,
    // Como leg, hay que incluir la información general, ya que Google solamente establece un leg
    leg: legUniqueData,
    // No tenemos datos de costes para fare por el momento, sería algo así:
    // Opción 1: itinerary.fare ? itinerary.fare.details : null
    // Opción 2: O hacer uso de la función comentanda mapFare
    fare: null
  }

  const polylineData = routeData.polyline.map(item => ([item.lat, item.lng]))
  if (polylineData.length === 0) {
    routeData.polyline = undefined
  }
  const dataPoints = {
    polyline: polylineData
  }
  const geojson = GeoJSON.parse(dataPoints, {LineString: 'polyline'})
  routeData.polyline = geojson

  return routeData
}

export default {
  /*
   * Solicita las rutas disponibles entre 2 direcciones (origen y destino).
   * DOCUMENTACIÓN DE LA VERSIÓN LIBRERÍA (SI NOS HA FUNCIONADO)
   *  https://developers.google.com/maps/documentation/javascript/directions
   * Decodificador de Polilíneas usado:
   *  https://www.npmjs.com/package/decode-google-map-polyline
   * Documentación de la versión API (NO NOS HA FUNCIONADO)
   * Documentación:
   *  https://developers.google.com/maps/documentation/directions/intro#DirectionsRequests
   * Parámetros:
   *  - origin
   *  - destination
   *  - key: API KEY de Google
   *  - mode: transit (transporte público). Si el modo es transporte público permite usar los
   *          parámetros departure_time, arrival_time, transit_mode y transit_routing_preference.
   *  - waypoints: puntos de ruta intermedios.
   *  - alternatives: true (varias rutas alternativas)
   *  - avoid: permite evitar determinados elementos. Admite tolls, highways, ferries e indoor.
   *  - language: idioma de la petición (https://developers.google.com/maps/faq#languagesupport)
   *  - units: unidad de medida. Admite metric o imperial.
   *           (https://developers.google.com/maps/documentation/directions/intro#UnitSystems)
   *  - region: código de la región (https://en.wikipedia.org/wiki/CcTLD,
   *            https://en.wikipedia.org/wiki/List_of_Internet_top-level_domains)
   *  - transit_mode: tipo de medio de transporte (bus, subway, train, tram, rail)
   *  - transit_routing_preference: (less_walking, fewer_transfers)
   */
  index( options ) {
    try {
      localStorage.setItem(MOVERICK_PLANNER_LOCALSTORAGE, JSON.stringify(options))

      // Solo para pruebas, simulando el GPS activo
      // options.origin = '39.46795083711362,-0.3847707503727827'
      // options.destination = '39.47052492018017,-0.3477840914768815'

      let url = options.otp_url
      url = url.endsWith('/') ? url : url + '/'
      url += `plan?fromPlace=${options.origin}&toPlace=${options.destination}`
      url = url.replace(/\/planplan\?/, '/plan?').replace(/\/plan\/plan\?/, '/plan?')

      // Verifica si options.transitOptions existe y si tiene al menos una propiedad definida
      if (options.transitOptions && Object.keys(options.transitOptions).length > 0) {
        if (options.transitOptions.departureTime != null ||
          options.transitOptions.arrivalTime !== null) {
          let fechaSalidaOLlegada = null

          if (options.transitOptions.departureTime != null) {
            fechaSalidaOLlegada = new Date(options.transitOptions.departureTime)
            url += '&arriveBy=false'
          } else if (options.transitOptions.arrivalTime != null) {
            fechaSalidaOLlegada = new Date(options.transitOptions.arrivalTime)
            url += '&arriveBy=true'
          } else {
            // Manejar el caso de error o simplemente omitirlo si no se necesita.
          }

          if (fechaSalidaOLlegada) {
            const hora = formatTime(fechaSalidaOLlegada)
            const dia = formatDate(fechaSalidaOLlegada)
            url += `&time=${hora}&date=${dia}`
          }
        }
      }

      // Añadir maxWalkDistance siempre para evitar que el planificador limite por defecto
      let maxWalkDistance = 5000;
      if (options.selectedTime) {
        const timeString = String(options.selectedTime);
        const minutes = parseInt(timeString.replace(/\D/g, ''), 10);
        if (!isNaN(minutes) && !timeString.includes('+')) {
          maxWalkDistance = minutes * 80;
        }
      }
      url += `&maxWalkDistance=${maxWalkDistance}`;

      // Reemplazar la construcción por defecto del modo
      if (options.params?.mode?.length > 0) {
        url += `&mode=${encodeURIComponent(options?.params?.mode)}`;
      } else {
        url += '&mode=TRANSIT%2CWALK' // Valor por defecto si no se proporciona `options.mode`
      }

      url += '&wheelchair=false&showIntermediateStops=true&debugItineraryFilter=false&locale=es&numItineraries=5'
      // Usar .includes para verificar si el modo contiene 'BICYCLE_RENT'
      if (options?.params?.mode?.includes('BICYCLE_RENT')) {
        url += '&walkReluctance=4';
      }
            url = url.replace(/ /g, '+')

      // Guarda la referencia del interceptor, header
      const myInterceptor = []

      // Remover temporalmente el interceptor
      Vue.http.interceptors.forEach((interceptor, index) => {
        if (typeof interceptor === 'function') {
          myInterceptor.push(interceptor)
          Vue.http.interceptors.splice(index, 1)
        }
      })

      return Vue.http.get(url).then(response => {
        const data = response.data
        const routes = data.plan ? data.plan.itineraries : []
        // Verificar si routes es un array vacío
        if (routes.length === 0) {
          // Devolver una promesa rechazada con un mensaje
          if (!data.plan || !Array.isArray(data.plan.itineraries)) {
            console.warn('Respuesta inválida de OTP. No se encontraron itinerarios.');
            return { routes: [] }; // Retorna un objeto estable con un array vacío
          }
          
          if (routes.length === 0) {
            console.warn('No se encontraron rutas en la respuesta.');
            return { routes: [] }; // Retorna un objeto vacío en vez de rechazar
          }
        }

        const mappedRoutes = routes.map(route => mapRoute(route))
        const responseData = {
          routes: mappedRoutes
        }

        // Volver a agregar el interceptor
        Vue.http.interceptors.push(...myInterceptor)

        return responseData
      })
    } catch (error) {
      // Manejo de errores
      // Volver a agregar el interceptor
      const myInterceptor = []
      Vue.http.interceptors.push(...myInterceptor)

      return Promise.reject(error)
    }
  }
}
